import { render, staticRenderFns } from "./Ordenacao.vue?vue&type=template&id=8617cdf8&scoped=true"
import script from "./Ordenacao.vue?vue&type=script&setup=true&lang=js"
export * from "./Ordenacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Ordenacao.vue?vue&type=style&index=0&id=8617cdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8617cdf8",
  null
  
)

export default component.exports